import axios from "axios";
import { baseUrl, api } from '../../utils/constants'

export const getDoctorDetails = async (doctorId) => {
    let response = await axios.get(baseUrl + "/user/" + doctorId)
    if (response && response.status === 200 || response.status === 201) {
        return response;
    }
    throw new Error("Failed to get code");
}